import React from "react";
import { HiLightningBolt, HiColorSwatch, HiTrendingUp, HiPresentationChartLine } from "react-icons/hi";

const services = [
    {
        title: "High-Retention VSL & Ad Creative Editing",
        description: "I specialize in \"Direct Response\" video editing. This isn't just about pretty cuts; it’s about conversion psychology. I craft the hooks, the pacing, and the visual storytelling that stops the scroll on Facebook and Instagram.",
        icon: <HiPresentationChartLine className="w-6 h-6 text-white" />,
    },
    {
        title: "Performance Product Imagery & Localization",
        description: "I transform raw product photos into high-end marketing assets. I also handle localization—adapting graphics, text, and imagery to fit specific global markets so the brand feels local and trustworthy.",
        icon: <HiTrendingUp className="w-6 h-6 text-white" />,
    },
    {
        title: "UI-Optimized Visual Asset Bundles",
        description: "I design the visual elements specifically for Landing Pages and Sales Funnels. This includes custom banners, trust badges, and hero sections that guide the user's eye toward the \"Buy\" button. My developer and I use a synchronized design workflow. He builds the layout in Systeme.io or VS code while I provide the pixel-perfect assets that fit the UI/UX like a glove.",
        icon: <HiColorSwatch className="w-6 h-6 text-white" />,
    },
    {
        title: "Full-Stack Creative Implementation",
        description: "This is our \"Done-For-You\" service where we collaborate as a Designer-Developer team. I handle all the creative content (Videos & Photos), and my developer builds the entire funnel architecture and logic.",
        icon: <HiLightningBolt className="w-6 h-6 text-white" />,
    },
];

const SpecializedServices = () => {
    // Duplicate services to create a smooth, continuous scrolling loop
    const scrollServices = [...services, ...services];

    return (
        <section className="pt-10 pb-20 bg-accent-black text-white overflow-hidden" id="services">
            <div className="container mx-auto px-6">
                <div className="text-left mb-12 max-w-2xl">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4 tracking-tight text-white">
                        Specialized Services
                    </h2>
                    <p className="text-zinc-500 text-lg leading-relaxed">
                        Strategic solutions designed to help E-commerce brands scale through high-performance funnels and creative excellence.
                    </p>
                </div>
            </div>

            <div className="service-container">
                <div className="service-track">
                    {scrollServices.map((service, index) => (
                        <div
                            key={index}
                            className="service-box p-8 rounded-xl bg-accent-dark border border-accent-border hover:border-white/20 transition-all duration-300 group flex flex-col items-start text-left shadow-none"
                        >
                            <div className="mb-6 p-3 rounded-lg bg-accent-border group-hover:bg-white group-hover:text-black transition-all duration-300">
                                {service.icon}
                            </div>
                            <h3 className="text-xl font-bold mb-4 text-white">
                                {service.title}
                            </h3>
                            <p className="text-zinc-400 text-sm leading-relaxed">
                                {service.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SpecializedServices;
